<template>
  <div id="content">
    <popup v-show="hasPopup"
           :popup-type="getPopupType"
           :popup-action="getPopupAction"
           @popup-action="executePopupAction"/>
    <div class="inner">
      <add-button v-if="$_createActionAllowed" :title="'Přidat skupinu oprávnění' | translate" route-name="roleGroupsNew"/>
      <h1 v-translate>Skupiny uživatelských oprávnění</h1>
    </div>
    <div class="inner_white">
      <div class="filter">
        <div class="field_left">
          <search-input input-class="search" v-model="formFields.search"></search-input>
        </div>
        <a @click.stop.prevent="resetFilter" class="btn btn_action btn_grey btn_reset" :title="'Resetovat filtr' | translate" v-translate>Resetovat filtr</a>
      </div>

      <div class="table_overflow">
        <table class="vypis vypis_detail">
        <thead>
        <tr v-if="entities.length > 0">
          <th class="no_padding drag_drop"></th>
          <th class="no_padding checkbox"/>
          <sorting-table-title
              v-for="title in roleGroupsTableTitles"
              :key="title.key"
              :column="title.column"
              :sort="getActiveSort(title.column)"
              @changeSorting="changeSorting"
          >{{ title.name }}
          </sorting-table-title>
          <th class="no_padding edit"/>
        </tr>
        </thead>

        <role-groups-row
            v-for="entity in entities"
            :entity="entity"
            :key="entity.id"
            :selectedEntities="selectedEntities"
            @input="select"
            @deleteRoleGroup="deleteEntity"
            :ref="'role-groups-row-ref-'+entity.id"
        />

        <tr v-if="entities.length === 0">
          <td :colspan="roleGroupsTableTitles.length+3">{{ $gettext('Nebyly nalezeny skupiny oprávnění.') }}</td>
        </tr>
      </table>
      </div>
      <list-action-line
          :entities="entities"
          :selected-entities="selectedEntities"
          :multiple-action-options="multipleActionOptions"
          @select-all="toggleSelectAll"
          @run-multiple-action="runMultipleAction"
          :offset="formFields.offset"
          :limit="formFields.limit"
          :total-count="totalCount"
          @limit="setLimit"
          @offset="setOffset"
          ref="action_line"
      ></list-action-line>
    </div>
  </div>
</template>

<script>
import listActions from "@/components/mixins/list-actions";
import RoleGroupsRow from "./RoleGroupsRow";

export default {
  name: "RoleGroupsDetail",
  mixins: [listActions],
  components: {RoleGroupsRow},
  data() {
    return {
      moduleName: "roleGroups"
    };
  },
  created(RoleGroupsService) {
    this.entityService = RoleGroupsService;
    this.createdInit();
  },
  computed: {
    roleGroupsTableTitles() {
      return [
        {key: 1, name: this.$gettext('Název skupiny'), column: 'sName'},
        {key: 2, name: this.$gettext('Kód'), column: 'sCode'},
        {key: 3, name: this.$gettext('Počet přiřazených uživatelů'), column: 'sUserCount'},
        {key: 4, name: this.$gettext('Vytvořeno'), column: 'sDateCreated'},
      ];
    },
    multipleActionOptions() {
      return [
        {value: 'choose', text: this.$gettext('Vyberte akci')},
        {value: 'exportCsv', text: this.$gettext('Exportovat do CSV')},
      ];
    },
    csvHeaders() {
      return this.getCsvHeaderFromSortingTableTitle(this.roleGroupsTableTitles);
    },
  }
};
</script>



// WEBPACK FOOTER //
// src/components/views/roleGroups/RoleGroupsList.vue